import { PageTransition } from '@/constant/transition'
import { container } from '@/style/container.css'
import { range } from '@/util'
import { zodResolver } from '@hookform/resolvers/zod'
import { getYear } from 'date-fns'
import { useAtom } from 'jotai'
import Button from 'react-bootstrap/Button'
import FloatingLabel from 'react-bootstrap/FloatingLabel'
import Form from 'react-bootstrap/Form'
import Stack from 'react-bootstrap/Stack'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import {
  basicJobApplicationInfoAtom,
  BasicJobApplicationInfoSchema,
  type BasicJobApplicationInfoForm,
} from './data'
import * as http from '@/util/http'
import { useMutation } from '@tanstack/react-query'

export default function BasicJobApplicationInfo() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [basicJobApplicationInfoData, setBasicJobApplicationInfoData] = useAtom(
    basicJobApplicationInfoAtom
  )
  // not necessary
  const { register, getValues, handleSubmit } = useForm({
    resolver: zodResolver(BasicJobApplicationInfoSchema),
    defaultValues: basicJobApplicationInfoData,
    mode: 'onChange',
  })
  const basicJobApplicationInfoMutation = useMutation({
    mutationFn: (payload: BasicJobApplicationInfoForm) =>
      http.put('/api/v1/user/profile', { payload }),
    onSuccess: () => {
      setBasicJobApplicationInfoData(getValues())
      navigate('/onboarding/occupation', {
        state: { direction: PageTransition.FromRight },
      })
    },
    onError: (err) => console.log(err),
  })

  const year = getYear(new Date())
  const maxSelectableYear = year + 10

  return (
    <div className={container}>
      <h1>{t('userInfo.basicJobApplicationInfo.title')}</h1>
      <FloatingLabel controlId="floatingInput" label="就職予定年" className="mb-3">
        <Form.Select {...register('targetEmploymentYear', { valueAsNumber: true })}>
          {Array.from(range(year, maxSelectableYear)).map((y) => (
            <option key={y} value={y}>
              {y}
            </option>
          ))}
          <option key={maxSelectableYear} value={maxSelectableYear}>
            {maxSelectableYear}以後
          </option>
        </Form.Select>
      </FloatingLabel>
      <Stack direction="horizontal" className="mt-3">
        <Button
          variant="outline-secondary"
          size="lg"
          onClick={() =>
            navigate('/onboarding/edu-info', {
              state: { direction: PageTransition.FromLeft },
            })
          }
        >
          ←
        </Button>
        <Button
          variant="outline-primary"
          size="lg"
          className="ms-auto"
          onClick={handleSubmit(
            (data) => basicJobApplicationInfoMutation.mutate(data),
            (err) => console.log(err)
          )}
        >
          →
        </Button>
      </Stack>
    </div>
  )
}
